<script setup>
import { computed } from 'vue';

const props = defineProps({
  hasLabelConfigs: {
    type: Boolean,
    default: false,
  },
  hasAgentConfigs: {
    type: Boolean,
    default: false,
  },
  hasTeamConfigs: {
    type: Boolean,
    default: false,
  },
});

const priorities = computed(() => {
  const blocked = props.hasLabelConfigs;
  
  return [
    { 
      number: 1, 
      title: 'Etiqueta', 
      description: 'Prioridade máxima',
      active: true,
    },
    { 
      number: 2, 
      title: 'Agente', 
      description: blocked ? '⚠️ Bloqueado por etiquetas' : 'Se não há etiqueta configurada',
      active: !blocked,
      blocked,
    },
    { 
      number: 3, 
      title: 'Time', 
      description: blocked ? '⚠️ Bloqueado por etiquetas' : 'Se não há agente configurado',
      active: !blocked,
      blocked,
    },
    { 
      number: 4, 
      title: 'Padrão', 
      description: blocked ? '⚠️ Bloqueado por etiquetas' : 'Caso não haja outra prioridade',
      active: !blocked,
      blocked,
    },
  ];
});
</script>

<template>
  <div class="mb-6 p-4 bg-n-solid-2 border border-n-weak rounded-xl">
    <div class="flex items-center gap-2 mb-3">
      <span class="i-lucide-layers text-n-slate-10 w-4 h-4" />
      <span class="text-sm font-medium text-n-slate-11">Ordem de prioridade</span>
    </div>
    
    <!-- Alerta quando há configs de etiqueta -->
    <div
      v-if="hasLabelConfigs"
      class="mb-3 p-3 bg-n-amber-3 border border-n-amber-6 rounded-lg flex items-start gap-2"
    >
      <span class="i-lucide-alert-triangle text-n-amber-11 w-4 h-4 flex-shrink-0 mt-0.5" />
      <div class="text-sm">
        <p class="text-n-amber-12 font-medium">Modo de etiquetas ativo</p>
        <p class="text-n-amber-11 mt-0.5">
          Apenas conversas com etiquetas configuradas serão resolvidas automaticamente. 
          Configurações de agente, time e padrão serão ignoradas.
        </p>
      </div>
    </div>
    
    <div class="flex flex-wrap gap-2">
      <div
        v-for="priority in priorities"
        :key="priority.number"
        :class="[
          'flex items-center gap-2 px-3 py-1.5 border rounded-lg transition-all',
          priority.blocked
            ? 'bg-n-slate-2 border-n-slate-6 opacity-50'
            : 'bg-n-solid-1 border-n-weak',
        ]"
      >
        <span
          :class="[
            'flex items-center justify-center w-5 h-5 rounded-full text-xs font-medium',
            priority.blocked
              ? 'bg-n-slate-4 text-n-slate-9'
              : 'bg-n-slate-9/10 text-n-slate-11',
          ]"
        >
          {{ priority.number }}
        </span>
        <span
          :class="[
            'text-sm font-medium',
            priority.blocked ? 'text-n-slate-9 line-through' : 'text-n-slate-12',
          ]"
        >
          {{ priority.title }}
        </span>
        <span
          :class="[
            'text-xs hidden sm:inline',
            priority.blocked ? 'text-n-slate-9' : 'text-n-slate-10',
          ]"
        >
          {{ priority.description }}
        </span>
      </div>
    </div>
  </div>
</template>